import { ConsentType } from "../constants/Consents";

export const EKYC_STATUS = {
  PENDING: "PENDING",
  SUCCESS: "SUCCESS",
  FAILED: "FAILED",
  INITIATED: "INITIATED",
};

export const EKYC_MESSAGES = {
  PROCESSING_REQUEST:
    "We’re still processing your request. This is taking a little longer than expected. Please wait.",
  MAX_ATTEMPT_TITLE: "Maximum Attempts Reached",
  MAX_ATTEMPT_TEXT:
    "You’ve reached the maximum number of attempts. Please contact Customer Care for assistance.",
  KYC_NOT_STARTED:
    "We couldn’t start your KYC process. Please try again later.",
  CONFIRMING_DETAILS:
    "Almost there! We’re confirming your details. Please wait.",
  ADDRESS_CONSENT_REQUIRED:
    "You must provide address consent to proceed with eKYC.",
  EKYC_CONSENT_REQUIRED: "You must provide eKYC consent to proceed.",
  STATUS_UNKNOWN_ERROR: "eKYC could not be completed. Please try again.",
  EKYC_INCOMPLETE: "eKYC Incomplete",
};